import classnames from 'classnames'

import Tooltip from 'src/ui/atoms/Tooltip'

export interface IInput {
  label: string
  name: string
  placeholder: string
  value?: string | number
  onChange?: any
  onBlur?: any
  labelPosition?: 'outside' | 'inside'
  error?: any
  info?: string
  search?: boolean
  disabled?: boolean
  dataCy?: string
  options: { text: string; value: string }[]
}

const Input = (
  {
    value,
    label,
    name,
    onChange,
    onBlur,
    placeholder,
    labelPosition = 'outside',
    error,
    info,
    search,
    disabled,
    options,
    dataCy,
  }: IInput,
  ref: any,
) => {
  return (
    <div className="grid">
      <div className="relative grid gap-3 self-end">
        <label
          className={classnames('text-base text-white', {
            'inline-block': labelPosition === 'outside',
            'absolute left-4 top-3': labelPosition === 'inside',
            '!left-12': search,
            '!text-gray': disabled,
          })}>
          <div className="flex flex-row items-center justify-start gap-1">
            {label}
            {info && (
              <span>
                <Tooltip tip={info}>
                  <span
                    className={classnames('icon-info text-base text-main-blue', {
                      '!text-gray': disabled,
                      'text-red': error,
                    })}></span>
                </Tooltip>
              </span>
            )}
          </div>
        </label>
        <select
          value={value}
          placeholder={placeholder}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          data-cy={dataCy}
          ref={ref}
          className={classnames(
            'autofill-polyfill appearance-none rounded-lg bg-white bg-opacity-5 py-6 pl-4 pr-10 font-normal text-white placeholder-white placeholder-opacity-50 outline-none focus:outline-main-blue',
            {
              'pb-3 pt-9': labelPosition === 'inside',
              '!pl-12': search,
              'pointer-events-none !bg-light-gray bg-opacity-100 !text-gray !placeholder-gray':
                disabled,
              'text-gray': disabled && labelPosition === 'outside',
              'outline-red': error,
            },
          )}>
          {options.map(({ text, value }, key) => (
            <option className="appearance-none bg-white p-2" key={key} value={value}>
              {text}
            </option>
          ))}
        </select>
        <span
          className={classnames(
            'icon-arrow-down pointer-events-none absolute bottom-4 right-4 cursor-pointer text-xl text-main-blue',
            {
              '!text-gray': disabled,
            },
          )}></span>
      </div>

      <p className="mt-1 text-sm text-red">{error?.message}</p>
    </div>
  )
}

export default Input
